import { Controller } from "@hotwired/stimulus"

// Chart.defaults.global.colors[0..2], which is what these series have always actually drawn with.
// An older red/light-grey/blue array existed but never rendered, because the canvas attribute
// carrying it was misspelled ("colours") and never bound. The legend stays off via the app-wide
// default in chart_defaults.js.
const SERIES = [
  { label: "Total Credit Given", key: "totalcredit", rgb: [151, 187, 205] },
  { label: "Total Cash Received", key: "totalcash", rgb: [220, 220, 220] },
  { label: "Net Gifts Revenue", key: "netgifts", rgb: [247, 70, 74] }
]

export default class extends Controller {
  static get targets() { return ["canvas"]; }
  static get values() { return { graph: Object }; }

  connect() {
    // No chart at all when the first dataset is empty, rather than an empty grid.
    var firstSeries = this.graphValue.totalcredit;
    if (!firstSeries || !firstSeries.length) { return; }

    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: {
        labels: this.graphValue.labels,
        datasets: SERIES.map((series) => ({
          label: series.label,
          data: this.graphValue[series.key],
          backgroundColor: this.seriesColor(series.rgb, 0.2),
          borderColor: this.seriesColor(series.rgb, 1),
          pointBackgroundColor: this.seriesColor(series.rgb, 1),
          pointHoverBackgroundColor: this.seriesColor(series.rgb, 0.8),
          pointBorderColor: "#fff",
          pointHoverBorderColor: this.seriesColor(series.rgb, 1)
        }))
      },
      options: { responsive: true, maintainAspectRatio: false }
    });
  }

  disconnect() {
    if (this.chart) { this.chart.destroy(); }
  }

  seriesColor(rgb, alpha) {
    return `rgba(${rgb.concat(alpha).join(",")})`;
  }
}
